import { combineReducers } from 'redux'

import {
  LOGOUT,
  RECEIVE_USERS,
  UPDATE_STATUS_SUCCESS,
  UPDATE_ROLE_SUCCESS,
  FETCH_LOGIN_TOKEN_SUCCESS,
  SHOW_ACTIVATE_DIALOG,
  HIDE_ACTIVATE_DIALOG,
  SELECT_ACTIVE_BUILDING,
  SELECT_ACTIVE_COMPANY,
  ACTIVATE_USER_SUCCESS,
  UPDATE_FILTER,
  DELETE_USER_SUCCEDED,
  UPDATE_BUILDINGS_SUCCESS,
  UPDATE_COMPANIES_SUCCESS,
  RESENT_EMAIL,
  RESENT_EMAIL_FAILED,
  CLOSE_RESENT_EMAIL,
  CHANGE_PAGE,
  CHANGE_SEARCH_STRING,
  SHOW_ADD_USERNAME_FORM,
  SHOW_USERNAME_DIALOG,
  UPDATE_USERNAME_SUCCESS,
  UPDATE_EMAIL_SUCCESS,
  CLOSE_USERNAME_DIALOG,
  CURRENT_USERNAME_CHANGED,
  CURRENT_EMAIL_CHANGED,
  SHOW_INACTIVE_USERS,
  SHOW_EMAIL_DIALOG,
  SHOW_SPINNER,
  SHOW_DEVICES_INFORMATION,
  CLOSE_DEVICES_INFORMATION
} from '../actions/users'

import { RECEIVED_COMPANIES } from '../actions/companies'

import { RECEIVED_BUILDINGS } from '../actions/buildings'

import storage from 'redux-persist/es/storage'
import { persistReducer } from 'redux-persist'

import locationsReducer from '../reducers/locations'
import eventsReducer from '../reducers/events'
import companiesReducer from '../reducers/companies'
import buildingsReducer from '../reducers/buildings'
import reportsReducer from '../reducers/reports'
import clustersReducer from '../reducers/clusters'
const config = {
  blacklist: ['routing'],
  key: 'root',
  storage
}

const authReducer = (state = {}, action) => {
  return state
}

const usersReducer = (
  state = {
    showActivateDialog: false,
    showEmailDialog: false,
    showUsernameDialog: false,
    selectedUser: null,
    filter: {
      buildingId: ' ',
      companyId: ' ',
      status: ' ',
      searchString: ' '
    }
  },
  action
) => {
  switch (action.type) {
    case RESENT_EMAIL:
      return {
        ...state,
        circularProgress: false,
        selectedUser: action.user,
        showResentEmailAlert: true,
        users: state.users.map(user => {
          if (user._id == action.user._id) {
            user.email = action.email
            return user
          }
          return user
        })
      }

    case RESENT_EMAIL_FAILED:
      return {
        ...state,
        error: action.error
      }

    case DELETE_USER_SUCCEDED:
      return {
        ...state,
        users: state.users.filter(user => {
          return user._id !== action.user._id
        })
      }

    case UPDATE_FILTER:
      return {
        ...state,
        filter: { ...state.filter, [action.filter]: action.value },
        pageOrFilterChanged: true,
        pageNumber: 1
      }

    case ACTIVATE_USER_SUCCESS:
      return {
        ...state,
        users: state.users.map(user => {
          return user._id === action.user._id ? action.user : user
        }),
        showActivateDialog: false,
        selectedUser: null,
        selectedBuildingId: null,
        selectedCompanyId: null
      }

    case SELECT_ACTIVE_BUILDING:
      return {
        ...state,
        selectedBuildingId: action.selectedBuildingId,
        pageOrFilterChanged: true,
        pageNumber: 1
      }

    case SELECT_ACTIVE_COMPANY:
      return {
        ...state,
        selectedCompanyId: action.selectedCompanyId,
        pageOrFilterChanged: true,
        pageNumber: 1
      }

    case HIDE_ACTIVATE_DIALOG:
      return {
        ...state,
        selectedUser: null,
        showActivateDialog: false,
        selectedBuildingId: null,
        selectedCompanyId: null
      }

    case SHOW_ACTIVATE_DIALOG:
      return {
        ...state,
        selectedUser: action.user,
        showActivateDialog: true
      }

    case LOGOUT:
      localStorage.removeItem('token')
      return {
        ...state,
        token: null,
        email: null
      }

    case RECEIVE_USERS:
      return {
        ...state,
        usersFetched: true,
        users: action.json.users,
        totalUsersAfterFilters: action.json.totalUsersAfterFilters,
        pageOrFilterChanged: false
      }

    case RECEIVED_BUILDINGS:
      return {
        ...state,
        buildingsFetched: true,
        buildings: action.json.buildings
      }

    case RECEIVED_COMPANIES:
      return {
        ...state,
        companiesFetched: true,
        companies: action.json.companies
      }

    case UPDATE_STATUS_SUCCESS:
      return {
        ...state,
        usersFetched: true,
        users: state.users.map(user => {
          return user._id === action.id ? Object.assign({}, user, { status: action.status }) : user
        })
      }

    case UPDATE_USERNAME_SUCCESS:
      return {
        ...state,
        usersFetched: true,
        users: state.users.map(selectedUser => {
          return selectedUser._id === action.id
            ? Object.assign({}, selectedUser, { fullName: action.fullName })
            : selectedUser
        }),
        selectedUser: undefined,
        showUsernameDialog: false
      }

    case UPDATE_EMAIL_SUCCESS:
      return {
        ...state,
        usersFetched: true,
        users: state.users.map(selectedUser => {
          return selectedUser._id === action.id
            ? Object.assign({}, selectedUser, { email: action.email })
            : selectedUser
        }),
        selectedUser: undefined,
        error: null
      }

    case UPDATE_ROLE_SUCCESS:
      return {
        ...state,
        usersFetched: true,
        users: state.users.map(user => {
          return user._id === action.id ? Object.assign({}, user, { role: action.role }) : user
        })
      }

    case UPDATE_BUILDINGS_SUCCESS:
      var buildings = []
      buildings = state.buildings.filter(building => {
        return action.buildings.indexOf(building._id) > -1
      })
      return {
        ...state,
        usersFetched: true,
        users: state.users.map(user => {
          return user._id === action.id ? Object.assign({}, user, { buildings: buildings }) : user
        })
      }

    case UPDATE_COMPANIES_SUCCESS:
      var companies = []
      companies = state.companies.filter(company => {
        return action.companies.indexOf(company._id) > -1
      })
      return {
        ...state,
        usersFetched: true,
        users: state.users.map(user => {
          return user._id === action.id ? Object.assign({}, user, { companies: companies }) : user
        })
      }

    case FETCH_LOGIN_TOKEN_SUCCESS:
      localStorage.setItem('token', action.token)
      return {
        ...state,
        token: action.token,
        email: action.email,
        name: action.name,
        id: action.id,
        role: action.role,
        error: action.error
      }

    case CHANGE_PAGE:
      return {
        ...state,
        pageNumber: action.pageNumber,
        pageOrFilterChanged: true
      }

    case CHANGE_SEARCH_STRING:
      return {
        ...state,
        searchString: action.searchString,
        usernameSearchValue: action.usernameSearchValue,
        pageOrFilterChanged: true,
        pageNumber: 1
      }

    case SHOW_ADD_USERNAME_FORM:
      return {
        ...state,
        fullName: action.fullName
      }

    case SHOW_USERNAME_DIALOG:
      return {
        ...state,
        selectedUser: action.selectedUser,
        showUsernameDialog: true,
        typedUsername: action.selectedUser.fullName
      }

    case SHOW_EMAIL_DIALOG:
      return {
        ...state,
        selectedUser: action.selectedUser,
        showEmailDialog: true,
        typedEmail: action.selectedUser.email,
        error: null
      }

    case SHOW_DEVICES_INFORMATION:
      return {
        ...state,
        selectedUser: action.selectedUser,
        showDevicesInformation: true,
        deviceType: action.deviceType
      }

    case SHOW_SPINNER:
      return {
        ...state,
        showSpinner: true
      }

    case CURRENT_USERNAME_CHANGED:
      return {
        ...state,
        typedUsername: action.typedUsername
      }

    case CURRENT_EMAIL_CHANGED:
      return {
        ...state,
        typedEmail: action.typedEmail,
        error: null
      }

    case CLOSE_RESENT_EMAIL:
      return {
        ...state,
        selectedUser: undefined,
        showEmailDialog: false,
        showSpinner: false,
        showResentEmailAlert: false,
        error: null
      }

    case CLOSE_USERNAME_DIALOG:
      return {
        ...state,
        selectedUser: undefined,
        showUsernameDialog: false
      }

    case CLOSE_DEVICES_INFORMATION:
      return {
        ...state,
        selectedUser: undefined,
        showDevicesInformation: false
      }

    case SHOW_INACTIVE_USERS:
      return {
        ...state,
        showInactiveUsers: action.showInactiveUsers,
        pageOrFilterChanged: true,
        pageNumber: 1
      }

    default:
      return {
        ...state,
        searchString: null,
        pageOrFilterChanged: false,
        showSpinner: false
      }
  }
}

const usersReducerPersisted = persistReducer(config, usersReducer)
const eventsReducerPersisted = persistReducer(config, eventsReducer)
const clustersReducerPersisted = persistReducer(config, clustersReducer)

const rootReducer = combineReducers({
  authReducer,
  usersReducer: usersReducerPersisted,
  eventsReducer: eventsReducerPersisted,
  buildingsReducer,
  companiesReducer,
  locationsReducer,
  reportsReducer,
  clustersReducer: clustersReducerPersisted
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js